import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import HolidayService from "../../services/holiday.services";

export const getHoliday = createAsyncThunk(
  "holiday/getHoliday",
  async (item, thunkAPI) => {
    try {
      const response = await HolidayService.getHoliday(item);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const addHoliday = createAsyncThunk(
  "holiday/addHoliday",
  async (data, thunkAPI) => {
    try {
      const response = await HolidayService.addHoliday(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);


export const updateHoliday = createAsyncThunk(
  "holiday/updateHoliday",
  async (payload, thunkAPI) => {
    try {
      const response = await HolidayService.editHoliday(payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const deleteHoliday = createAsyncThunk(
  "holiday/deleteHoliday",
  async (id, thunkAPI) => {
    try {
      const response = await HolidayService.deleteHoliday(id);
      return id;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);


const initialState = {
  loading: false,
  error: null,
  holidayList: [],
};


const holidaySlice = createSlice({
  name: "holiday",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(getHoliday.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(getHoliday.fulfilled, (state, action) => {
        state.loading = false;
        state.holidayList = action.payload?.data || [];
      })

      .addCase(getHoliday.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default holidaySlice.reducer;
